import { IconButton, IconButtonProps } from '@material-ui/core';
import React from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';

type MoreVertButtonProps = IconButtonProps & {

}

function MoreVertButtonComponent (props: MoreVertButtonProps) {
    return (
        <IconButton {...props}>
            <MoreVertIcon />
        </IconButton>
    )
}

export const MoreVertButton = React.memo(MoreVertButtonComponent);